<template>
  <dropdown class="dropup">
    <template v-slot:trigger>
      {{ title }}
    </template>
    <dropdown-option
      v-for="link in links"
      :key="link.url"
      :href="link.url"
    >
      {{ link.title }}
    </dropdown-option>
  </dropdown>
</template>

<script>

import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  name: 'FooterItem',

  components: {
    Dropdown,
    DropdownOption
  },

  props: {
    title: {
      type: String,
      default: () => '',
    },

    links: {
      type: Array,
      default: () => null,
    },
  },
}
</script>

<style lang="scss">
  .footer-bar {
    .dropdown-toggle {
      border: none;
    }
  }
</style>
